import {FC, useState, createContext, useContext} from 'react'
import { BurningItem } from './_models'

const ListViewContext = createContext<{itemIdForUpdate?: BurningItem, setItemIdForUpdate?: any}>({})

const ListViewProvider: FC = ({children}) => {
  const [itemIdForUpdate, setItemIdForUpdate] = useState<BurningItem>()

  return (
    <ListViewContext.Provider
      value={{
        itemIdForUpdate,
        setItemIdForUpdate,
      }}
    >
      {children}
    </ListViewContext.Provider>
  )
}

const useListView = () => useContext(ListViewContext)

export {ListViewProvider, useListView}
